import { ActionTypes } from 'redux/utils/List'

export default ActionTypes('SCHEDULING_COMMUNITY_LIST')